import styled from "styled-components";
import { BREAK_POINT } from "../constants";

interface CardProps {
  id: string;
  title: string;
  sub?: string;
  handleClick: () => void;
}

const Card = ({ id, title, sub, handleClick }: CardProps) => {
  return (
    <Wrapper onClick={handleClick}>
      <ThumbnailWrapper>
        <Thumbnail $source={`/assets/${id}`} />
      </ThumbnailWrapper>
      <TextWrapper>
        <div className="title">{title}</div>
        <div className="sub">{sub}</div>
      </TextWrapper>
    </Wrapper>
  );
};

export default Card;

const Wrapper = styled.div`
  width: 30%;
  background: var(--pink);
  text-align: center;
  font-family: "Pretendard";
  color: var(--darkPrimary);
  cursor: pointer;

  ::-moz-selection {
    background: transparent;
  }

  ::selection {
    background: transparent;
  }

  @media only screen and (min-width: ${BREAK_POINT.tablet}) {
    min-width: 360px;
    max-width: 384px;
  }

  @media only screen and (max-width: ${BREAK_POINT.tablet}) {
    min-width: 320px;
    white-space: pre;
  }
`;

const ThumbnailWrapper = styled.div`
  width: 100%;
  padding: 40px 40px 30px;

  @media only screen and (max-width: ${BREAK_POINT.tablet}) {
    padding: 20px;
  }
`;

const Thumbnail = styled.div<{ $source: string }>`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  background: ${({ $source }) => $source && `url(${$source}) no-repeat`};
  background-size: contain;
  background-position: center;
  background-color: var(--pink);
`;

const TextWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media only screen and (min-width: ${BREAK_POINT.tablet}) {
    padding-bottom: 40px;
    .title {
      font-weight: 700;
      font-size: 2.3rem;
    }
    .sub {
      font-weight: 400;
      font-size: 2rem;
      margin-top: 8px;
    }
  }

  @media only screen and (max-width: ${BREAK_POINT.tablet}) {
    padding-bottom: 20px;
    .title {
      font-size: 2.6rem;
      font-weight: 700;
      margin-top: 4px;
    }
    .sub {
      font-size: 2.5rem;
      margin-top: 8px;
      font-weight: 400;
    }
  }
`;
